import { atomWithStorage } from "jotai/utils";

const NAV_MODE_KEY = "nav-mode";

export type NavMode = "auto-detect" | "mouse" | "trackpad";

export const navModeAtom = atomWithStorage<NavMode>(NAV_MODE_KEY, "auto-detect");
